export default (theme) => ({
    pageRoot: {
        minHeight: '100vh',
        width: '100%',
        boxSizing: 'border-box',
    },
    pageRootWithBg: {
        backgroundColor: theme.colors.grey[900],
        backgroundPositionX: 0,
        backgroundPositionY: 0,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
});
